import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { handleBackgroundImg, handleLogin } from 'api-services/auth';
import { createNotification } from 'common/create-notification';

export const useLogin = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleBackgroundImg();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(loginSchema)
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    handleLogin({ setIsLoading, data, history, dispatch }).then((res) => {
      if (res?.status === 200) {
        history.push(`${process.env.REACT_APP_FOLDER_NAME}/dashboard`);
        createNotification('success', 'Logged In Successfully');
      }
    });
  };

  return {
    handleSubmit,
    onSubmit,
    register,
    errors,
    isLoading
  };
};

export const loginSchema = yup.object().shape({
  email: yup.string().required('Email is required').email(),
  password: yup.string().required('Password is required')
});
